module.exports = __webpack_public_path__ + "static/media/sv-swiper3.a386c68e.png";